import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { throwError, Observable, of, timer } from 'rxjs';
import { catchError, retryWhen, mergeMap, map } from 'rxjs/operators';
import { StrmErrData } from '@app/core/interfaces/strm-interfaces';

@Injectable({
    providedIn: 'root'
})
export class XHttpService {
    constructor(
        @Inject(DOCUMENT)
        private doc: Document,
        @Inject(PLATFORM_ID)
        private pid: any,
        private http: HttpClient,
        private r: Router,
    ) { }

    formatErrors(error: any) {
       error.status != 404 ? console.log('formatErrors', error):null;
        const data = error.error || {};
        let text: any;

        if (data && Array.isArray(data)) {
            text = data.map(function (item) {
                return item['message'];
            }).join('\n');

                    } else if (data && data['status']) {
            if ((typeof data === 'object') && data['message']) {
                text = data['message'];
            }
        } else if (data && data['message']) {
            try {
                const _parse = JSON.parse(data['message']);
                if (_parse && _parse['error'] && _parse['error']['message']) {
                    text = _parse['error']['message'];
                }
            } catch (e) {
                text = data['message'];
            }
        }
        if (!text) {
            text = 'Что-то пошло не так';
        }
        if (text) {
            error.status != 404 ? console.error(text):null
        }
        return throwError(error);
    }

    private __api(): string {
        return environment.domains.API;
    }

    get(path: string, params: HttpParams = new HttpParams(), options: any = {}): Observable<any> {
        const dn = path.indexOf(':silent:') >= 0;
        if (dn) {
            path = path.substr(8);
        }
        const observable = this.http.get(`${this.__api()}${path}`, Object.assign({}, options, { params: params }));
        return observable.pipe(
            retryWhen(this.retryStrategy({maxRetryAttempts: 1, onStatusCodes: [502], scalingDuration: 2000})),
            dn? map(x => x) : catchError(this.formatErrors.bind(this))
        );
    }

    post(path: string, body: Object = {}, options: Object = {}): Observable<any> {
        path.indexOf('infringement') === -1 ? body = JSON.stringify(body):null
        const dn = path.indexOf(':silent:') >= 0;
        if (dn) {
            path = path.substr(8);
        }
        const observable = this.http.post(
            `${this.__api()}${path}`,
            body,
            options
        );
        if (dn) {
            return observable;
        }
        return observable.pipe(catchError(this.formatErrors.bind(this)));
    }

    httpParams(params: any): HttpParams {
        for (const k in params) {
            if (params[k] === null || params[k] === void 0) {
                delete params[k];
            }
        }
        return new HttpParams({ fromObject: params });
    }
    catchErrorPage(isStream: boolean = false): any {
        return catchError(response => {
            let par: any = { code: response.status }
            par['message'] = response.error && response.error.message ? response.error.message : 'Ошибка сервера'
            if (response.error && response.error.resolve) {
                par['data'] =  this.getErrData(response.error.resolve, isStream)
            } else {
                par['data'] = null
            }
            par['isStream'] = isStream
            this.r.navigate(['/error/'], { skipLocationChange: true, queryParams: par} as NavigationExtras);
            return response.status != 404 ? throwError(response) : of()
        });
    }
    getErrData(data: any, isStream: boolean = false): string {
        let d: any = {}
        if (isStream) {
            d['sport'] = data.pageSport
            d['tournament'] = data.pageTournament
            d['others'] = data.pageOthers
        } else {
            d['sport'] = data.mapSport
            d['tournament'] = data.mapTournament
            d['others'] = data.pageOthers

        }
        return JSON.stringify(d as StrmErrData)
    }
    delete(path:any, params: HttpParams = new HttpParams(), options: any = {}): Observable<any> {
        return this.http.delete(`${environment.domains.API}${path}`, Object.assign({}, options, { params: params })).pipe(catchError(this.formatErrors.bind(this)));
      }
    retryStrategy = ({
        maxRetryAttempts = 3,
        scalingDuration = 1000,
        onStatusCodes = []
    }: {
        maxRetryAttempts?: number,
        scalingDuration?: number,
        onStatusCodes?: number[]
    } = {}) => (attempts: Observable<any>) => {
        return attempts.pipe(
          mergeMap((error, i) => {
            const retryAttempt = i + 1;
            if (
              retryAttempt > maxRetryAttempts ||
              !onStatusCodes.find(e => e === error.status)
            ) {
              return throwError(error);
            }
            return timer(retryAttempt * scalingDuration);
          })
        );
    };
}

